/*
 * File: card.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:30:15
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseComponent } from "@root/components/base-classes";
import { PropInnateSync } from "@root/core/vue-props";

/// refined at 2023/12/12
@Component
export default class Card extends BaseComponent {
    /// public props /////////////////////////
    @PropInnateSync("visible", { type: Boolean, default: true })
    innateVisible!: boolean;

    /// available slots /////////////////////
    publicSlots = {
        toolbox: "@toolbox",
        footer: "@footer",
        label: "@label",
        "footer-before": "@footer-before",
        "footer-after": "@footer-after",
    };

    /// public method
    public open() {
        this.innateVisible = true;
    }
    public close() {
        this.innateVisible = false;
    }
    public toggle() {
        if (this.innateVisible === true) this.close();
        else this.open();
    }

    /// private helper
    hasTabChild() {
        // This assumes you have a way to uniquely identify Tab components,
        // such as a specific prop value, a data attribute, or a component name
        const slots = this.$slots.default || [];
        let containsTab = false;

        const checkSlots = (vNodes) => {
            for (const vNode of vNodes) {
                if (
                    vNode.componentOptions &&
                    vNode.componentOptions.Ctor.name === "Tabs"
                ) {
                    containsTab = true;
                    break; // Exit if a Tab is found
                }
                if (vNode.children) {
                    checkSlots(vNode.children); // Recursively check for nested children
                }
            }
        };

        checkSlots(slots);
        return containsTab;
    }
}
